function httpConfig (config = null) {
  if (!config) {
    config = {
      headers: {},
      params: {},
    }
  }

  if (!config.params) {
    config.params = {}
  }

  if (auth.isLogged()) {
    config.headers = _.merge(auth.headers, {
      Accept: 'application/json',
    }, config.headers)
  }
  return config
}

export default httpConfig
